// extracted by mini-css-extract-plugin
export var biolinkbutton = "DogBioLinks-module--biolinkbutton--18671";
export var buttons = "DogBioLinks-module--buttons--08ce1";
export var buttonsireland = "DogBioLinks-module--buttonsireland--394d5 DogBioLinks-module--buttons--08ce1";
export var dogbiolinkscontainer = "DogBioLinks-module--dogbiolinkscontainer--61e2d";
export var dogbiolinkscontainerireland = "DogBioLinks-module--dogbiolinkscontainerireland--7b8ec DogBioLinks-module--dogbiolinkscontainer--61e2d";
export var login = "DogBioLinks-module--login--19179";
export var loginlink = "DogBioLinks-module--loginlink--f292b";
export var modalcontainer = "DogBioLinks-module--modalcontainer--e2733";
export var socmed = "DogBioLinks-module--socmed--2f6a9";
export var socmedicons = "DogBioLinks-module--socmedicons--93968";
export var socmedtitle = "DogBioLinks-module--socmedtitle--762b3";
export var title = "DogBioLinks-module--title--43120 headings-module--sectionHeadingSmall--b489b";